import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import Icon from '@mdi/react';
import { useState } from 'react';

function FaqSection() {
  const [faqKey, setFaqKey] = useState(null);

  const faqs = [
    {
      key: 1,
      title: 'What is Gartekcloude?',
      content:
        'GartekCloude is an EdTech platform that offers students access to course materials, academic tools, and collaboration features.',
    },
    {
      key: 2,
      title: 'How does GartekCloude contribute to learning?',
      content:
        'GartekCloude provides resources, tools, and reminders that simplify learning and keep students organized.',
    },

    {
      key: 3,
      title: 'What materials are available on Gartekcloude?',
      content:
        'Gartekcloude offers comprehensive materials, personalized study plans, Advanced-powered tools, and a supportive community for',
    },

    {
      key: 4,
      title: ' Can I sell my own content on Gartekcloude?',
      content:
        'Yes, you can sell your own content materials on the GartekCloude platform for free.',
    },

    {
      key: 5,
      title: 'What plans are available on GartekCloude?',
      content:
        'We offer Free and Premium plans. Details will be shared at the full launch.',
    },

    {
      key: 6,
      title: 'Is my data secure on Gartekcloude?',
      content:
        'Yes, we use encryption and secure storage to protect your data.',
    },

    {
      key: 7,
      title: 'Who can use GartekCloude?',
      content:
        'Students, both undergraduate and postgraduate, can use GartekCloude.',
    },
  ];

  function toggleFaq(key) {
    if (faqKey === key) {
      setFaqKey(-1);
      return;
    }

    setFaqKey(key);
  }

  return (
    <section className="py-9 px-5 flex flex-col gap-8 lg:flex-row" id="faqs">
      <header className="min-w-max">
        <h2 className="text-3xl lg:text-6xl text-black-variant font-extrabold mb-5">
          <span className="fancy-text">Frequently</span>
          <br />
          <span className="text-gold lg:text-black-variant text-shadow-black">
            Asked Questions ?
          </span>
        </h2>
      </header>
      <div className="faqs-container">
        <div className="gap-3 flex flex-col">
          {faqs.map((faq) => {
            const { content, key, title } = faq;
            return (
              <div
                className={`${faqKey === key ? 'gap-2.5' : 'gap-0'} transition-all duration-200 ease-in-out flex flex-col`}
                key={key}
              >
                <header
                  className="items-center flex justify-between py-3 px-2 rounded-lg bg-white-variant hover:bg-gold-variant"
                  onClick={() => {
                    toggleFaq(key);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') toggleFaq(key);
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <h3 className="text-xs md:text-lg">{title}</h3>
                  <span
                    className={`${faqKey === key ? 'icon-container' : 'hidden'}`}
                  >
                    <Icon path={mdiChevronUp} />
                  </span>
                  <span
                    className={`${faqKey === key ? 'hidden' : 'icon-container'}`}
                  >
                    <Icon path={mdiChevronDown} />
                  </span>
                </header>
                <div
                  className={`${faqKey === key ? 'h-max' : 'h-0'} overflow-hidden  transition-all duration-200 ease-in-out px-2 text-black-opaque-6 text-[10px] md:text-base`}
                >
                  {content}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
